import React, { useEffect, useState } from 'react'
import './EmailChatSection.css'
import EmailService from '../../../common/util/EmailService';
import Config from '../../../config.json'
import { useParams } from 'react-router-dom';
import { Button, Modal, Popover, Select, Spin } from 'antd';
import AwsServerService from '../../../common/util/AwsServerService';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EmailMimic from './EmailMimic';
import axios from 'axios';
import { getEmailsFromString } from '../../../components/EmailSection/emailUtil';
import { faDownload, faPaperclip, faFilter, faTimes, faComments, faUser, faProjectDiagram } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { AutoComplete} from 'antd';
 
 
export default function EmailChatSection({ location, getParams, taskROWID, taskType,
  clickedFromBody,
        handleNotificationHyperlink,
        allTask,
        viewTaskData,
        allUsers,
        cacheDeals, 
        dealObj,
        fromtask,
}) {
  const [loader, setLoader] = useState(false);
  const [emailsInfo, setEmailsInfo] = useState({ Email: {}, Action: "" });
    const [emailsData, setEmailsData] = useState([]);
    const [emailsCacheData, setEmailsCacheData] = useState([]);
    const [composePopup, setComposePopup] = useState(false);
    const [refreshEnable, setRefreshEnable] = useState(false);
    const [selectedMail, setSelectedMail] = useState({data:{},action:null});
    const [showSearch, setShowSearch] = useState(false);  
    const [emailSuggestions, setEmailSuggestions] = useState([]);
 
const [filterOptions, setFilterOptions] = useState({
  from: '',
  to: [],
  subject: '',
  body: '',
  fromDate: '',
  toDate: '',
  size: '',
  hasAttachment: false,
});
 
 
  const moduleContacts = useSelector((state) => state.AppReduxContext.moduleContacts);
  // const AppReduxContext = useSelector((state) => state.AppReduxContext);
  console.log("hiii")
  console.log("moduleContacts:- ",moduleContacts);
useEffect(() => {
  let arrayData = [];
  if (
    moduleContacts &&
    _.isObject(moduleContacts)
  ) {
    const data = { ...moduleContacts };
 
    Object.keys(data).forEach(key => {
      data[key]?.forEach(rec => {
        if (rec.Email) {
          arrayData.push({
            name: rec.Full_Name || '', // Full_Name or whatever key name
            email: rec.Email
          });
        }
      });
    });
 
    // Remove duplicate emails (case-insensitive)
    const seen = new Set();
    const uniqueEmails = arrayData.filter(({ email }) => {
      const lower = email.toLowerCase();
      if (seen.has(lower)) return false;
      seen.add(lower);
      return true;
    });
 
    setEmailSuggestions(uniqueEmails);
  }
}, [moduleContacts]);
// }, [AppReduxContext]);
 
 
 
 
 
useEffect(() => {
  const filterString = Object.entries(filterOptions)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0 ? `${key}: ${value.join(', ')}` : '';
      } else if (typeof value === 'boolean') {
        return value ? `${key}: true` : '';
      } else {
        return value ? `${key}: ${value}` : '';
      }
    })
    .filter(Boolean)
    .join(' | ');

  setGlobalSearch(filterString);
}, [filterOptions]);

 
 
 
const getInitials = (name = '') => {
  const words = name.trim().split(' ');
  if (words.length === 1) return words[0][0]?.toUpperCase();
  return (words[0][0] + words[1][0])?.toUpperCase();
};
 
const getColor = (name = '') => {
  const colors = ['#4A90E2', '#50E3C2', '#F5A623', '#9013FE', '#D0021B'];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};
 
 
const [filterApplied, setFilterApplied] = useState(false);
const [globalSearch, setGlobalSearch] = useState('');
      function GetAllEmailMessages(accountId, folderId, token, IdsToExtract) {
        return new Promise((resolve, reject) => {
            let config = {
                Type: 'Get',
                url: `https://mail.zoho.com/api/accounts/${accountId}/messages/view?limit=1000&folderId=${folderId}`,
                headers: { Authorization: `Bearer ${token}` }
            };
            axios.post(Config.backend_aws_server_url + 'zoho/workdrive', { config })
                .then((result) => {  
           
                  if (Array.isArray(result?.data?.data)) {
                    result.data.data.forEach(one => { one.accountId = accountId; });
            result.data.data = result.data.data.filter(rec => {
              let ref = rec.references;
              if (typeof ref === "string") {
                ref = [ref];
              }
              if (IdsToExtract.includes(rec.messageId) || IdsToExtract.includes(rec.subject) || IdsToExtract.includes("RE: " + rec.subject) || (IdsToExtract.includes(rec.inReplyTo))) {
                return true
              } else if (ref && ref.some(re => IdsToExtract.includes(re))) {
                return true
              }
              return false;
            });
                  }
                    resolve(result.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    useEffect(()=>{
      if(!selectedMail.action){
        setEmailsData(emailsCacheData);
      }
    },[emailsCacheData,selectedMail.action])
 
      const getAllMailData = async (folders, accountId, token, IdsToExtract) => {
        try {
          const results = await Promise.all(folders.map(folderId => GetAllEmailMessages(accountId, folderId, token, IdsToExtract)));
          const allData = results.flatMap(result => result.data);
          return allData;
        } catch (error) {
          console.error('Error fetching emails:', error);
        }
      }
      async function modifyData(data, allUsers) {
        const results = await Promise.all(
          data.map(async (parsedEmail, index) => {
            const [toAddress, ccAddress, bccAddress] = await Promise.all([
              getEmailsFromString(parsedEmail.toAddress, allUsers).then(data =>
                data?.map(d => ({ email: d.email, id: index })) || []
              ),
              parsedEmail.ccAddress !== "Not Provided"
                ? getEmailsFromString(parsedEmail.ccAddress, allUsers).then(data =>
                    data?.map(d => ({ email: d.email, id: index })) || []
                  )
                : [],
              getEmailsFromString(parsedEmail.bccAddress, allUsers).then(data =>
                data?.map(d => ({ email: d.email, id: index })) || []
              )
            ]);
     
            return {
              from: [{ email: parsedEmail.fromAddress, id: index }],
              to: toAddress,
              cc: ccAddress,
              bcc: bccAddress,
              subject: parsedEmail.subject,
              body: parsedEmail.summary,
              date: parsedEmail.sentDateInGMT,
              messageId: parsedEmail.messageId,
          folderId: parsedEmail.folderId,
          accountId: parsedEmail.accountId,
              references: parsedEmail?.references,
              inReplyTo: parsedEmail?.inReplyTo,
              attachments: parsedEmail.hasAttachment !== "0",
              accountMail: true
            };
          })
        );
        return results;
      }
     
  async function getTokensWithEmails(emails) {
    let arry = Object.keys(emails).map(re => `'${re}'`)
    EmailService.getAllUsersTokens(arry).then(res => {
       
      Promise.all(res.map(rec => getAllMailData([rec.Inbox, rec.Sent], rec.accountId, rec.AccessToken, emails[rec.UserEmail]))).then(async result => {
        console.log("all mails from account data", result[0]);
        let data = await modifyData(result[0], allUsers);
        console.log("all mails from account data", data);
        data = data.map(rec => { return { ...rec, date: moment.utc(Number(rec.date)).subtract(7, 'hours').toISOString() } })
          //  let allData =[...emailsData,...data];
          //  allData=allData?.sort((a, b) => new Date(b.date) - new Date(a.date));
                  setEmailsCacheData(prevEmails => {
  const combined = [...prevEmails, ...data];
  const unique = _.uniqBy(combined, 'messageId');  
  return unique.sort((a, b) => new Date(b.date) - new Date(a.date));
});
           setLoader(false);
        }).catch(err => {
          console.log("Error fetching email data:", err);
        });
      }).catch(err => {
        console.log("Error fetching user tokens:", err);
      });
      }
  const getDataForEmails = () => {
        const email = allTask?.TaskFlowObject?.BotAccountEmail;
    AwsServerService.getMessageIDsForEmailAutomation(taskROWID, taskType).then(res => {
      let data = res?.data;
          let emailsObj = {};
      for (let i = 0; i < data?.length; i++) {
        if (emailsObj[data[i].EmailAddress]) {
              emailsObj[data[i].EmailAddress].push(data[i].MessageID)
        } else {
          emailsObj[data[i].EmailAddress] = [data[i].MessageID]
            }
          }
          let messageIds = emailsObj[email];
          delete emailsObj[email];
          setLoader(true)
      AwsServerService.getEmailsForEmailAutomation(messageIds).then(response => {
            setLoader(false);
            setRefreshEnable(false);
        let data = [...response?.data?.inbox, ...response?.data?.sent];
            // let allData =[...emailsData,...data];
            // allData=allData?.sort((a, b) => new Date(b.date) - new Date(a.date));
                  setEmailsCacheData(prevEmails => {
  const combined = [...prevEmails, ...data];
  const unique = _.uniqBy(combined, 'messageId');  
  return unique.sort((a, b) => new Date(b.date) - new Date(a.date));
});
      }).catch(err => {
            setLoader(false)
            // setEmailsData([]);
            setRefreshEnable(false);
          })
          getTokensWithEmails(emailsObj)
        })
      }
  useEffect(() => {
    if (taskROWID && taskType) {
      getDataForEmails();
    }
  }, [taskROWID])
  useEffect(() => {
    if (refreshEnable) {
      getDataForEmails();
    }
  }, [refreshEnable])
  const [contextPosition, setContextPosition] = useState({ index: null, top: 0, left: 0 });
    const contextMenu = (
        <div>
      <Button style={{ width: '100%',display:'flex',flexDirection: 'row',justifyContent: 'right' }} onClick={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedMail({...selectedMail,action:true});
        let id=[selectedMail.data.messageId]
        if(selectedMail?.data?.accountMail){
          setLoader(true);
          let token=await EmailService.getAllUsersTokens([`'${selectedMail.data.from?.map(e=>e.email)[0]}'`]);
          EmailService.GetRelatedEmails(selectedMail.data.accountId,id,token[0].AccessToken).then(async res=>{
            if(res.data.length>0){
              let data = await modifyData(res.data, allUsers);
              data = data.map(rec => { return { ...rec, date: moment.utc(Number(rec.date)).subtract(7, 'hours').toISOString() } })
              setEmailsData(data);
            }else{
              setEmailsData([selectedMail.data])
            }
            setLoader(false);
          }).catch(err=>{
            console.log(err);
            setLoader(false)})
        }else{
        let data=emailsData.filter(rec => {
          let ref = rec.references;
          if (typeof ref === "string") {
            ref = [ref];
          }
          if (id.includes(rec.messageId) || (id.includes(rec.inReplyTo))) {
            return true
          } else if (ref && ref.some(re => id.includes(re))) {
            return true
          }
          return false;
        });
        setEmailsData(data);
      }
       }}>
            <FontAwesomeIcon style={{padding:'2px',color:'gray'}} icon={faProjectDiagram} /> Related emails by Thread
          </Button>
          <Button style={{ width: '100%',display:'flex',flexDirection: 'row',justifyContent: 'center' }} onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setSelectedMail({ ...selectedMail, action: true }); 
            let subject = selectedMail?.data?.subject?.toLowerCase();
            if (!subject) return; 
            if(subject.includes(': ')){
              subject = subject.split(': ')[1];
            }
            const data = emailsData.filter(rec =>rec.subject?.toLowerCase().includes(subject)); 
            setEmailsData(data);
          }}>
            <FontAwesomeIcon icon={faComments} /> Emails in this conversation
          </Button>
          <Button style={{ width: '100%',display:'flex',flexDirection: 'row',justifyContent: 'center'}} onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setSelectedMail({ ...selectedMail, action: true }); 
            const senderEmail = selectedMail?.data?.from?.[0]?.email?.toLowerCase();
            if (!senderEmail) return; 
            const data = emailsData.filter(rec =>rec.from?.some(sender => sender.email?.toLowerCase() === senderEmail));
            setEmailsData(data);
          }}>
            <FontAwesomeIcon style={{padding:'2px',color:'gray'}} icon={faUser} /> Messages from this sender
          </Button>

        </div>
      );
  const handleContextMenu = (e, email, index) => {
      setSelectedMail({data:email,action:null});
      e.preventDefault();  
      setContextPosition({
      index: index,
        top: e.clientY + 10,
        left: e.clientX + 10,  
      });
    };
    function composeMailPopup() {
      return <Modal
      maskClosable={false}
      destroyOnClose={true}
      title={`Email`}
      open={composePopup}
      onCancel={() => {
        setComposePopup(false)
        setEmailsInfo({ Email: {}, Action: "" })
      }
      }
      onClose={() => {
        setComposePopup(false)
        setEmailsInfo({ Email: {}, Action: "" })
      }}
      footer={null}
      className="testModalCompose"
    >
      <EmailMimic 
        // {...props}
        clickedFromBody={clickedFromBody}
        location={location}
        handleNotificationHyperlink={handleNotificationHyperlink}
        task={allTask}
        viewTaskData={viewTaskData}
        allUsers={allUsers}
        cacheDeals={cacheDeals}
        refreshEnable={false}
        setRefreshEnable={setRefreshEnable}
        getParams={getParams}
        dealObj={dealObj}
        fromtask={true}
        setComposePopup={setComposePopup}
        setEmailData={() => { }}
        emailsInfo={emailsInfo}
        setEmailsInfo={setEmailsInfo}
      />
    </Modal>
    }
    const convertToText = (html) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    };
    return (<>
        <div className="chat-container">  
          {loader?<Spin />:<></>}
          {composeMailPopup()}
          <div style={{ position: 'absolute', top: '1em', right: '1em', display: 'flex', gap: '0.5em', alignItems: 'center' }}>
          {selectedMail.action && <FontAwesomeIcon style={{color:'red'}} onClick={e=>setSelectedMail({data:{},action:null})} icon={faTimes} title='Remove related emails filter'/>}
          <div className="search-input-wrapper">
 <input
    type="text"
    placeholder="Search emails..."
    value={globalSearch}
    onChange={(e) => setGlobalSearch(e.target.value)} // To enable searching
    className="search-input"
     style={{ marginLeft: "-35px" }}
  />
  <FontAwesomeIcon
    icon={faFilter}
    className={`filter-icon ${filterApplied ? 'active' : ''}`}
    onClick={() => setShowSearch(prev => !prev)} // Toggle filter display
    title="Show filters"
  />
</div>
  <Button
    type="primary"
    style={{ height: '2em', fontWeight: '500', background: '#2188f8' }}
    onClick={() => {
      setEmailsInfo({ Action: 'compose', Email: {} });
      setComposePopup(true);
    }}
  >
    Compose
  </Button>
</div>
 
{showSearch && (
  <div className="gmail-style-filter">
    {/* <div className="filter-header">Advanced Search</div> */}
    <div className="filter-fields">
<div className="filter-row">
  <label>From</label>
<AutoComplete
  options={emailSuggestions.map(item => ({
    value: item.email,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: '50%',
            backgroundColor: getColor(item.name),
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 10
          }}
        >
          {getInitials(item.name || item.email)}
        </div>
        <div>
          <div style={{ fontWeight: '500' }}>{item.name}</div>
          <div style={{ fontSize: '12px', color: 'gray' }}>{item.email}</div>
        </div>
      </div>
    )
  }))}
  value={filterOptions.from}
  onChange={(value) =>
    setFilterOptions((prev) => ({ ...prev, from: value }))
  }
  style={{
    width: '75%',
    height: '40px',
    fontSize: '14px'
  }}
  placeholder="Enter email or name"
  filterOption={(inputValue, option) => {
    const search = inputValue.toLowerCase();
    const email = option?.value?.toLowerCase();
    const name = emailSuggestions.find(
      e => e.email.toLowerCase() === option.value.toLowerCase()
    )?.name?.toLowerCase() || '';
    return email.includes(search) || name.includes(search);
  }}
/>
 
 
 
 
 
 
 
</div>
 
<div className="filter-row">
  <label>To</label>
<Select 
  mode="tags"
  options={emailSuggestions.map(item => ({
    value: item.email,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: '50%',
            backgroundColor: getColor(item.name),
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 10
          }}
        >
          {getInitials(item.name || item.email)}
        </div>
        <div>
          <div style={{ fontWeight: '500' }}>{item.name}</div>
          <div style={{ fontSize: '12px', color: 'gray' }}>{item.email}</div>
        </div>
      </div>
    )
  }))}
  value={filterOptions.to}
  onChange={(value) =>
    setFilterOptions((prev) => ({ ...prev, to: value }))
  }
  style={{
    width: '75%',
    maxHeight: '100px', // Increase height so multiple lines fit
    overflowY: 'auto', // Scroll if too many tags
    fontSize: '14px',
    whiteSpace: 'normal', // Important: allow wrapping
    display: 'flex',
    flexWrap: 'wrap', // Allow tags to wrap
  }}
  placeholder="Enter recipient email or name"
  filterOption={(inputValue, option) => {
    const search = inputValue.toLowerCase();
    const email = option?.value?.toLowerCase();
    const name = emailSuggestions.find(
      e => e.email.toLowerCase() === option.value.toLowerCase()
    )?.name?.toLowerCase() || '';
    return email.includes(search) || name.includes(search);
  }}
  optionLabelProp="label"
/>

</div>
 
 
      <div className="filter-row">
        <label>Subject</label>
        <input type="text" value={filterOptions.subject} onChange={(e) => setFilterOptions(prev => ({ ...prev, subject: e.target.value }))} />
      </div>
      <div className="filter-row">
        <label>Includes words</label>
        <input type="text" value={filterOptions.body} onChange={(e) => setFilterOptions(prev => ({ ...prev, body: e.target.value }))} />
      </div>
      <div className="filter-row">
  <label>From Date</label>
  <input
    type="date"
    value={filterOptions.fromDate}
    onChange={(e) =>
      setFilterOptions((prev) => ({ ...prev, fromDate: e.target.value }))
    }
  />
</div>
 
<div className="filter-row">
  <label>To Date</label>
  <input
    type="date"
    value={filterOptions.toDate}
    onChange={(e) =>
      setFilterOptions((prev) => ({ ...prev, toDate: e.target.value }))
    }
  />
</div>
 
      {/* <div className="filter-row">
        <label>File Size</label>
        <input type="number" value={filterOptions.size} onChange={(e) => setFilterOptions(prev => ({ ...prev, size: e.target.value }))} />
      </div> */}
      <div className="filter-row">
        <label>Has Attachments</label>
        <input type="checkbox" checked={filterOptions.hasAttachment} onChange={(e) => setFilterOptions(prev => ({ ...prev, hasAttachment: e.target.checked }))} />
      </div>
    </div>
    <div className="filter-actions">
      <Button type="primary" onClick={() => { setShowSearch(false); setFilterApplied(true); }}>Search</Button>
<Button onClick={() => {
  setFilterOptions({
    from: '',
    to: [],
    subject: '',
    body: '',
    fromDate: '',
    toDate: '',
    size: '',
    hasAttachment: false,
  });
  setFilterApplied(false);
  setGlobalSearch(''); // Reset global search when filters are cleared
  setShowSearch(false); // Close the filter panel
}}>Clear</Button>
 
    </div>
  </div>
)}
 
 
 
 
{emailsData.filter(email => {
  const emailDate = moment(email.date);
  const fromDateMatch = !filterOptions.fromDate || emailDate.isSameOrAfter(moment(filterOptions.fromDate), 'day');
  const toDateMatch = !filterOptions.toDate || emailDate.isSameOrBefore(moment(filterOptions.toDate), 'day');
  const sizeMatch = !filterOptions.size || (email.size || 0) >= parseInt(filterOptions.size);
  // const hasAttachmentMatch = !filterOptions.hasAttachment || email.attachments === true;
  const hasAttachmentMatch =
  !filterOptions.hasAttachment ||
  email.attachments === true ||
  (Array.isArray(email.attachments) && email.attachments.length > 0);  
 
  const fromMatches = !filterOptions.from || email.from?.some(e => e.email.toLowerCase().includes(filterOptions.from.toLowerCase()));
  // const toMatches = !filterOptions.to || email.to?.some(e => e.email.toLowerCase().includes(filterOptions.to.toLowerCase()));
  // const filterTo = typeof filterOptions.to === 'string' ? filterOptions.to.toLowerCase() : '';
  // const toMatches = !filterTo || email.to?.some((e) => e.email?.toLowerCase().includes(filterTo));
const toFilters = Array.isArray(filterOptions.to) ? filterOptions.to.map(email => email.toLowerCase())  : [];
const toMatches = toFilters.length === 0 || email.to?.some(e =>  typeof e.email === 'string' && toFilters.some(filter => e.email.toLowerCase().includes(filter)));
  const subjectMatches = !filterOptions.subject || email.subject?.toLowerCase().includes(filterOptions.subject.toLowerCase());
  const bodyMatches = !filterOptions.body || convertToText(email.body || '').toLowerCase().includes(filterOptions.body.toLowerCase());
 
  // Apply advanced filters only if enabled
  if (filterApplied) {
    return fromMatches && toMatches && subjectMatches && bodyMatches &&
           fromDateMatch && toDateMatch && sizeMatch && hasAttachmentMatch;
  }
 
  // If only globalSearch is active
  if (globalSearch) {
    const search = globalSearch.toLowerCase();
    const fromEmails = email.from?.map(e => e.email).join(' ').toLowerCase() || '';
    const toEmails = email.to?.map(e => e.email).join(' ').toLowerCase() || '';
    const subject = email.subject?.toLowerCase() || '';
    const body = convertToText(email.body || '').toLowerCase();
    return fromEmails.includes(search) || toEmails.includes(search) || subject.includes(search) || body.includes(search);
  }
 
  return true;
})
.map((email, index) => (
            <div key={index} className={`email-tile`} onContextMenu={(e) => handleContextMenu(e, email,index)} onClick={async ()=>{
              if(email.accountMail){
                let token=await EmailService.getAllUsersTokens([`'${email.from?.map(e=>e.email)[0]}'`]);
                 EmailService.GetAttachmentsInfo( email.accountId,email.folderId,email.messageId,token[0].AccessToken).then(async r=>{
                   
                     setComposePopup(true);
                     let obj={...email}
                     obj["attachments"]=[];
                     obj["attachmentsInfo"]=r?.data?.attachments;
                     obj["token"]=token[0].AccessToken;
                      setEmailsInfo({Email:obj,Action:'viewemail'})
                    }).catch(err=>setEmailsInfo({Email:{...email,attachments:[],attachmentsInfo:[]},Action:'viewemail'}))
              }else{
                setEmailsInfo({Email:email,Action:'viewemail'})
                setComposePopup(true)
              }
              }
              }>
              <Popover
                content={contextMenu}
                open={contextPosition.index == index}
                placement="bottomLeft"  
                style={{
                  position: 'absolute',
                  top: contextPosition?.top,
                  left: contextPosition?.left,
                  zIndex: 9999,
                }}
                trigger="click"  
                onOpenChange={() => setContextPosition({...contextPosition,index:null})}
              ></Popover>
              <div style={{display:'flex',position: 'relative'}}><span className='sender'>From: </span>
              <div className='Elipsis-Class' style={{maxWidth:'86%%', textIndent:'2px'}}>{email.from?.map(e=>e.email).join('; ')}</div>
              {((email.accountMail && email.attachments)||(email.attachments?.length>0))&&<span style={{position:'absolute',top:'0',right:'0'}}><FontAwesomeIcon icon={faPaperclip}/></span>}</div>
              <div className="Elipsis-Class"><span className='sender'>To: </span>{email.to?.map(e=>e.email).join('; ')}</div>
              <div className="Elipsis-Class"><span className='sender'>Subject: </span>{email.subject}</div>
              <div className="Elipsis-Class" style={{maxHeight:'3em',whiteSpace:'normal'}}>
                {/* <span className='sender'>Content: </span> */}
                {convertToText(email.body)}</div>
              <div className="timeDiv">{moment(email.date).format('MM/DD/YYYY hh:mm A')}</div>
            </div>
          ))}
        </div></>
      );
}